import "./MainContainer.scss";

import React, { useEffect } from "react";
import { Route, Switch, useHistory } from "react-router-dom";

import PageNoteFound from "../../utils/PageNotFound";
import { MyMicroFrontend } from "./MainContainer.utils";

const MainContainer = () => {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  const loginPermission = permissions?.filter((f) => f.visible && f.isModule);
  const history = useHistory();

  useEffect(() => {
    if (window.location.pathname.includes("/case/")) {
      history.push("/viewcases?redirectURL=case");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  useEffect(() => {
    const handleBackButton = () => {
      if (window.location.pathname.includes("/case")) {
        history.push("/viewcases");
      }
    };
    window.addEventListener("popstate", handleBackButton);
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [history]);

  return (
    <div className="content-wrapper">
      <section className="content-header">
        <Switch>
          {loginPermission.map((route) => (
            <Route
              key={route.moduleName?.toLocaleLowerCase()}
              path={`/${route.moduleName?.toLocaleLowerCase()}`}
              component={() => <MyMicroFrontend route={route} />}
            />
          ))}
          <Route path="*" render={() => <PageNoteFound />} />
        </Switch>
      </section>
    </div>
  );
};

export default MainContainer;
